import { gql } from '@apollo/client';
import resourceFragment from './resourceFragment';

const UPDATE_RESOURCES = gql`
  mutation UpdateResources($updatedResources: [ResourceInput]!, $removedResourceIds: [Int]) {
    updateResources(updatedResources: $updatedResources, removedResourceIds: $removedResourceIds) {
      ...resourceFragmentFields
    }
  }

  ${resourceFragment}
`;

export default UPDATE_RESOURCES;
